import HttpService from '../baseHttp'
// 库存分配列表
export const HttpGetStockDistributionList = (data = {}, config) => HttpService.get('/api/v2/StockBaseTemplate/findByPage', { params: data })
// 规则详情
export const HttpGetStockDistribution = (data = {}, config) => HttpService.get('/api/v2/StockBaseTemplate/getById', { params: data })
// 保存
export const HttpSaveStockDistributionData = (data = {}, config = {}) => HttpService.post("/api/v2/StockBaseTemplate/save", data, { ...config, headers: { "Content-Type": "application/json" } });
// 失效
export const HttpCancelStockDistribution = (data = {}, config) => HttpService.get('/api/v2/StockBaseTemplate/cancel', { params: data })
// 复制sku
export const HttpCopySKU = (data = {}, config) => HttpService.get('/api/v2/StockBaseTemplate/sku/save', { params: data })
// 操作历史
export const HttpSysOpLog = (data = {}, config) => HttpService.get('/api/v1/SysOpLog/findByPage', { params: data })



